<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    let bgColor = "#000";
    let title = "丝瓜";
    let color = [
      "#c065e7",
      "#765deb",
      "#3862d8",
      "#6a89E2",
      "#219CF9",
      "#6efbbf",
      "#40c057",
      "#ffd351",
      "#ff8e43",
      "#f56b6d",
    ];
    let echartData = [
      {
        name: "2020",
        value: "810",
      },
      {
        name: "2021",
        value: "1190",
      },
      {
        name: "2022",
        value: "1400",
      },
      {
        name: "2023",
        value: "1650",
      },
    ];
    let formatNumber = function (num) {
      let reg = /(?=(\B)(\d{3})+$)/g;
      return num.toString().replace(reg, ",");
    };
    let total = echartData.reduce((a, b) => {
      return a + b.value * 1;
    }, 0);

    this.state.chart.setOption({
      color: color,
      tooltip: {
        trigger: "item",
      },
      title: [
        {
          text: "{name|" + title + "}\n" + "种植面积",
          top: "center",
          left: "center",
          textStyle: {
            fontSize: 24,
            fontWeight: "normal",
            color: "#fff",
            rich: {
              name: {
                fontSize: 30,
                fontWeight: "normal",
                color: "#fff",
                padding: [10, 0],
              },
              val: {
                fontSize: 32,
                fontWeight: "bolder",
                color: "#fff",
              },
            },
          },
        },
        {
          text: "亩",
          top: 20,
          left: 20,
          textStyle: {
            fontSize: 14,
            color: "#666666",
            fontWeight: 400,
          },
          show: false,
        },
      ],
      series: [
        {
          type: "pie",
          roseType: "radius",
          radius: ["35%", "60%"],
          center: ["50%", "50%"],
          data: echartData,
          hoverAnimation: false,
          itemStyle: {
            normal: {
              borderColor: bgColor,
              borderWidth: 2,
            },
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 60,
              lineStyle: {
                // color: '#e6e6e6'
              },
            },
          },
          label: {
            normal: {
              formatter: (params) => {
                return (
                  "{icon|●}{name|" +
                  params.name +
                  "}\n{value|" +
                  formatNumber(params.value) +
                  "亩}"
                );
              },
              // padding: [0 , -100, 25, -100],
              rich: {
                icon: {
                  fontSize: 24,
                  color: "inherit",
                },
                name: {
                  fontSize: 24,
                  padding: [0, 0, 0, 10],
                  color: "#fff",
                },
                value: {
                  fontSize: 28,
                  fontWeight: "normal",
                  padding: [10, 0, 0, 20],
                  color: "inherit",
                  // color: '#333333'
                },
              },
            },
          },
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
